/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/*! messaging.js | Huro | Css Ninja. 2020-2021 */

import { retrieveFromStorage } from "../../Components/Functions";
import { USER_AUTHENTICATION_DATA } from "../../Redux/User/types";
import { authentication, base } from "../../Server/Api";
import { formatMessageBox } from "./mesagingUtils";

const { user } = retrieveFromStorage(USER_AUTHENTICATION_DATA)||{};
const loggedUser = user || {};



export const initMessaging = ({ fetchChatWith }) => {
    var noavatar = require("../../assets/images/placeholder.png").default;
    
	if (
		($("#hide-chat-side").on("click", function () {
			$(".chat-body-wrap, .message-field-wrapper").addClass("side-collapsed"),
				$(".chat-side-fab")
					.addClass("is-active")
					.removeClass("is-mobile-active"),
				$(".chat-side").removeClass("is-mobile-active");
		}),
		$(".chat-side-fab").on("click", function () {
			$(this).removeClass("is-active").addClass("is-mobile-active"),
				$(".chat-body-wrap, .message-field-wrapper").removeClass(
					"side-collapsed",
				),
				$(".chat-side").addClass("is-mobile-active");
		}),
		$(
			"#messages-sidebar li, .collapsed-messaging li, #mobile-conversations-list li",
		).on("click", function () {
			$(".chat-header .is-autocomplete").addClass("is-hidden");
			$(this);
			var a = $(this).attr("data-conversation-menu");
			$(
				"#messages-sidebar li, .collapsed-messaging li, #mobile-conversations-list li",
			).removeClass("is-active"),
				fetchChatWith(a)
		}),
		$("#users-autocpl").length)
	) {
		var a = { 
			url: base+"/users/admin/searchpatients/",
            ajaxSettings: {
                dataType: "json",
                method: "POST",
                data: {
                  dataType: "json",
                },
                headers: {
                    Authorization: `Bearer ${authentication?.access}`
                }
            },            
			getValue: "username",
			template: {
				type: "custom",
				method: function (a, s) {
					// return (
					// 	""
					// );
                    return (`
                    <div
                        class=template-wrapper><div class=avatar-wrapper>
                        <img class=autocpl-avatar src='${(s.image || noavatar)}' /></div>
                        <div class=entry-text>${s.name}<br><span>
                        @${s.username} | ${s.address_location}
                        </span></div></div> 
                    `)
				},
			},
			highlightPhrase: !1,
			list: {
				maxNumberOfElements: 10,
				showAnimation: { type: "fade", time: 400, callback: function () {} },
				match: { enabled: !0 },
				onChooseEvent: function () {
					var a = $("#users-autocpl").val();
					    $("#users-autocpl").val(""),
                        fetchChatWith(a),
						$(".is-chat").hasClass("is-hidden") &&
							$(".is-chat, .is-chat-placeholder").toggleClass("is-hidden"),
						$("#chat-body li:not(.no-messages):not(.chat-loader)").remove(),
						$(".chat-header .is-autocomplete").addClass("is-hidden");
				},
			},
		};
		$("#users-autocpl").easyAutocomplete(a);
	}
	$("#users-autocpl").on("change", function () {
		$(".start-conversation").removeClass("is-disabled");
	}),
		$(".start-conversation").on("click", function () {
			$(".chat-header .is-autocomplete").removeClass("is-hidden"),
				$("#users-autocpl").focus(),
				$(".chat-body li:not(.no-messages):not(.chat-loader)").remove(),
				$(".chat-body .no-messages").removeClass("is-hidden"),
				$("#messages-sidebar ul li").removeClass("is-active"),
				"development" == env
					? $(".chat-side #user-details-image").attr(
							"src",
							require("../../assets/images/placeholder.png").default,
					  )
					: $(".chat-side #user-details-image").attr(
							"src",
							require("../../assets/images/placeholder.png").default,
					  ),
				$(".chat-side")
					.find(".user-name, .info, .user-skills, .user-job-title")
					.empty();
		}),
		$(".chat-header .hide").on("click", function () {
			$(".chat-header .is-autocomplete input").val(""),
				$(".chat-header .is-autocomplete").addClass("is-hidden");
		});

}


export const getTimeNow = () => {
    var d = new Date().toLocaleTimeString("en").split(":");
    return d = d[0]+":"+d[1]+d[2].split(" ")[1];
}


export const composeChat = ({id, sender, avatar,  type, text, time }) => {
    return {
        "id": id || new Date().getTime(),
        "type": type,
        "sender": "self",
        "avatar": avatar,
        "content": {
            "text": text,
            "time": time || getTimeNow()
        }
    }
}